import { VStack } from '@bpba/ui-components';
import { FormChildProps } from '../../types/FormChildProps';
import { StyledSpan } from '../shared/StyledSpan';
import { FormInputs } from './FormInputs';
import { IconedLabel } from './IconedLabel';

export function InvitadosComponent(props: FormChildProps) {
  return (
    <VStack alignItems={'end'} marginY={'20px'}>
      <IconedLabel text="Invitada/o" inverse={true}>
        {props.indexed && <StyledSpan fontWeight={'700'}>{props.index}</StyledSpan>}
      </IconedLabel>
      {FormInputs(props)}
    </VStack>
  );
}
